export default __webpack_public_path__ + "static/media/cover.dfe7f9f4.jpg";